/* ========================================================================== *\
    Imports
/* ========================================================================== */
import { isElement, reduce, keys, forEach, indexOf } from 'lodash';

import { store } from '../2-utilities/store';
import { publish, subscribe } from '../2-utilities/event';
import { isDesktop } from '../2-utilities/breakpoint';

import {
    YEAR_SELECTED as yearSelected,
    AUTOPLAY_NEXT_ITEM as toNextItem,
    QUIT_AUTOPLAY as quitAutoplay,
    YEAR_CHANGED
} from '../3-data/consts/eventNames';

/* ========================================================================== *\
    Constants
/* ========================================================================== */
const moduleName = 'paging',
    baseSelector = `.js-${moduleName}`,
    baseClassName = `c-${moduleName}`,
    jsClassName = `js-${moduleName}`,
    classNames = {
        base: baseClassName,
        item: `${baseClassName}__item`,
        year: `${baseClassName}__year`,
        indicator: `${baseClassName}__indicator`
    },
    jsClassNames = {
        base: jsClassName,
        item: `${jsClassName}-item`,
        indicator: `${jsClassName}-indicator`,
        range: `${jsClassName}-range`
    },
    selectors = {
        base: baseSelector,
        item: `.${jsClassNames.item}`,
        indicator: `.${jsClassNames.indicator}`,
        range: `.${jsClassNames.range}`
    },
    attributes = {
        index: `data-${moduleName}-index`,
        year: `data-${moduleName}-year`
    },
    { ranking } = store;

let currentYear;

/* ========================================================================== *\
    Templating
/* ========================================================================== */
function getIndicatorHtml() {
    return `
        <span class="${classNames.indicator} ${jsClassNames.indicator}">
        </span>
    `;
}

function getItemHtml(years) {
    return reduce(
        years,
        (memo, year, index) => {
            return memo += `
                <a 
                    class="${classNames.item} ${jsClassNames.item}" 
                    ${attributes.index}="${index}"
                    ${attributes.year}="${year}"
                >
                    <span class="${classNames.year}">${year}</span>
                </a>
            `;
        },
        ''
    );
}

function getTemplate(years) {
    return `
        <div class="${classNames.base}">
            <div class="${classNames.base}__container">
                ${getItemHtml(years)}
            </div>
            ${getIndicatorHtml()}
        </div>
    `;
}

/* ========================================================================== *\
    Functionality
/* ========================================================================== */
function setActiveClass() {
    const items = document.querySelectorAll(selectors.item);
    const item = document.querySelector(`[data-paging-year="${currentYear}"]`);

    forEach(items, el => {
        el.classList.remove('is-active');
    });

    item.classList.add('is-active');
}

function moveIndicator(element) {
    const indicator = document.querySelector(selectors.indicator);
    indicator.style.setProperty('transform', `translateX(${element.offsetLeft}px)`);

    //change active year text color
    if (!isDesktop()) {
        const items = document.querySelectorAll(selectors.item);
        forEach(items, item => {
            const yearElement = item.querySelector("span");
            const year = item.getAttribute(attributes.year);
            year == currentYear ? yearElement.style.setProperty('color', '#fff') : yearElement.style.setProperty('color', '#000');
        })
    }
}

function clickHandler() {
    const element = this,
        selectedYear = element.getAttribute(attributes.year);

    currentYear = selectedYear;

    setActiveClass();
    moveIndicator(element);
    publish(quitAutoplay);
    publish(yearSelected, { selectedYear });
}

function binding() {
    const items = document.querySelectorAll(selectors.item);

    forEach(items, item => {
        item.addEventListener('click', clickHandler);
    })
}

function selectPrevYear() {
    const years = keys(ranking),
        currentIndex = indexOf(years, currentYear);

    let index = currentIndex - 1;

    if (index < 0) {
        index = years.length - 1;
    }

    const selectedYear = years[index],
        element = document.querySelector(`[${attributes.year}="${selectedYear}"]`);

    currentYear = selectedYear;

    setActiveClass();
    moveIndicator(element);
    publish(yearSelected, { selectedYear });
}

function setup(element) {
    const years = keys(ranking),
        template = getTemplate(years);

    currentYear = years[years.length - 1];

    element.innerHTML = template;

    const startElement = document.querySelector(`[${attributes.year}="${currentYear}"]`);
    setActiveClass();
    moveIndicator(startElement);

    binding();
}

function init(baseElement = document.querySelector(selectors.base)) {
    if (!isElement(baseElement)) {
        return false;
    }

    setup(baseElement);

    const range = document.querySelector(selectors.range);
    range.addEventListener('change', () => {
        const selectedYear = range.value,
            element = document.querySelector(`[${attributes.year}="${selectedYear}"]`);

        currentYear = selectedYear;

        setActiveClass();
        moveIndicator(element);
        publish(yearSelected, { selectedYear });
        publish(YEAR_CHANGED);
    })
}

init();
subscribe(toNextItem, selectPrevYear);